import { GatsbyImage } from 'gatsby-plugin-image';

const GatsbyImageWrapper = ({ alt = '', image, ...props }) => {
  return <GatsbyImage backgroundColor="transparent" alt={alt} image={image} {...props} />;
};

export default GatsbyImageWrapper;
